import { defineComponent as _defineComponent } from 'vue'
import { getStateColour } from '@/utils/color';
import TableWithActions2 from '@/components/tableWithActions/TableWithActions2.vue';
import CellWithSubtitle from '@/components/tableWithActions/CellWithSubtitle.vue';
import { isEmpty, isNil } from '@/utils/misc';
import { devicesService } from '@/services/devices.service';
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import {
  CutOrTubesGanttItem,
  CutOrTubesIntradayAvailabilityDeviceData,
  CutOrTubesDeviceGanttStatus,
} from '@/models/Charts/chartsData';
import { CutOrTubesIntradayAvailabilityGanttGenerator } from '@/models/Charts/gantt/cutOrTubesIntradayAvailabilityGanttGenerator';
import CutOrTubesIntradayAvailabilityFilters from './CutOrTubesIntradayAvailabilityFilters.vue';
import GanttChartRow from '../GanttChartRow.vue';
import GanttTimelineRow from '../GanttTimelineRow.vue';
import {
  getDefaultZoomValues,
  getFormattedStatusDuration,
} from '@/utils/gantt';
import { last } from '@/utils/array';
import { values } from '@/utils/enum';
import { useI18n } from '@/composables/i18n';
import { computed, nextTick, ref, watch } from 'vue';
import { addDataTestIdAttributeToTh } from '@/utils/table';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'CutOrTubesIntradayAvailabilityTable',
  props: {
    widgetDefinition: null,
    data: null,
    loading: { type: Boolean }
  },
  emits: ['refresh'],
  setup(__props: any, { emit }) {

const props = __props as {
  widgetDefinition: WidgetDefinition;
  data: CutOrTubesIntradayAvailabilityDeviceData[] | null;
  loading: boolean;
};





const { t } = useI18n();

const states = ref<CutOrTubesDeviceGanttStatus[]>(
  values(CutOrTubesDeviceGanttStatus),
);

const defaultZoomValues = ref<[Date, Date]>(getDefaultZoomValues());
const zoomValues = ref<[Date, Date]>(getDefaultZoomValues());

const isGanttColumnExpanded = ref(false);
// Used just as a workaround (see workaroundTableOverflowOnStatusColumnsAdded)
const isGanttColumnShown = ref(true);

function getDeviceNameByStringId(deviceStringId: string): string {
  // eService center may load this component before the customer's devices
  // are fetched, so don't assume it'll be found.
  return devicesService.store.getNameByStringId(deviceStringId) ?? '';
}

function refresh() {
  emit('refresh');
}

function onFiltersChanged(
  newStates: CutOrTubesDeviceGanttStatus[],
  newZoomValues: [Date, Date],
  areApplying: boolean,
  next: (filterValues: Record<string, any>, areApplying: boolean) => void,
) {
  states.value = newStates;
  zoomValues.value = newZoomValues;
  workaroundTableOverflowOnStatusColumnsAdded();
  next({}, areApplying);
}

function filterDeviceDataByStatuses(
  data: CutOrTubesGanttItem[],
  states: string[],
): CutOrTubesGanttItem[] {
  return data.filter((dataItem) => states.includes(dataItem.value));
}

function onExpandGanttColumnToggled() {
  isGanttColumnExpanded.value = !isGanttColumnExpanded.value;
  workaroundTableOverflowOnStatusColumnsAdded();
}

watch(
  () => props.data,
  () => {
    defaultZoomValues.value = getDefaultZoomValues();
    zoomValues.value = defaultZoomValues.value;
  },
);

/**
 * Workarounds the table overflowing its container when a status column is added.
 *
 * When a column is added columns width isn't recalculated, so the new columns
 * are just added, provoking and overflow.
 *
 * This is a hack that triggers a re-render of the Gantt charts, so their
 * widths and their columns adapt to the new available width. This is done by
 * hiding and showing again the Gantt column.
 */
function workaroundTableOverflowOnStatusColumnsAdded() {
  isGanttColumnShown.value = false;
  nextTick(() => (isGanttColumnShown.value = true));
}

const coalescedData = computed<CutOrTubesIntradayAvailabilityDeviceData[]>(
  () => props.data ?? [],
);

const generator = computed(
  () =>
    new CutOrTubesIntradayAvailabilityGanttGenerator(
      props.widgetDefinition.widget,
    ),
);

return { __sfc: true,props, emit, t, states, defaultZoomValues, zoomValues, isGanttColumnExpanded, isGanttColumnShown, getDeviceNameByStringId, refresh, onFiltersChanged, filterDeviceDataByStatuses, onExpandGanttColumnToggled, workaroundTableOverflowOnStatusColumnsAdded, coalescedData, generator, getStateColour, TableWithActions2, CellWithSubtitle, isEmpty, isNil, CutOrTubesIntradayAvailabilityFilters, GanttChartRow, GanttTimelineRow, getFormattedStatusDuration, last, addDataTestIdAttributeToTh }
}

})